import * as React from 'react';
import { Logbog } from '../../models/Logbog';
import { ValidationResult } from '../../infrastructure/ValidationResult';
import { PageTitle } from '../../uiComponents/layout/PageTitle';
import { PageWrapper } from '../../uiComponents/layout/PageWrapper';
import { RouteComponentProps } from 'react-router';
import { ContentWrapper } from '../../uiComponents/layout/ContentWrapper';
import LogbogCreateUpdate from './LogbogCreateUpdate';
import { LogbogAfsnit } from '../../models/LogbogAfsnit';
import { createApiCaller } from '../../infrastructure/api/ApiFactory';
import NotificationQueue from '../../uiComponents/layout/NotificationQueue';
import NotificationData from '../../uiComponents/layout/NotificationData';
import { Redirect } from 'react-router-dom';

export interface LogbogCreateUpdateContainerProps extends RouteComponentProps<any> {
}

interface OpgavepakkeCreateContainerState {
    logbog: Logbog;
    validationResult?: ValidationResult;
    isSaved: boolean;
    isSubmitting: boolean;
    isRemoved: boolean;
}

class LogbogCreateUpdateContainer extends React.Component<LogbogCreateUpdateContainerProps, OpgavepakkeCreateContainerState> {
    constructor(props: LogbogCreateUpdateContainerProps) {
        super(props);
        this.state = {
            logbog: new Logbog(),
            validationResult: new ValidationResult(),
            isSaved: false,
            isSubmitting: false,
            isRemoved: false
        };

        this.getLogbog = this.getLogbog.bind(this);
        this.getErrorMessages = this.getErrorMessages.bind(this);
        this.onLogbogChanged = this.onLogbogChanged.bind(this);
        this.onLogbogSave = this.onLogbogSave.bind(this);
        this.onLogbogDelete = this.onLogbogDelete.bind(this);
        this.removeAfsnit = this.removeAfsnit.bind(this);
        this.addAfsnit = this.addAfsnit.bind(this);
        this.onAfsnitChanged = this.onAfsnitChanged.bind(this);
        this.getIsNew = this.getIsNew.bind(this);
    }

    setStateWithLogbog(logbog: Logbog): void {
        this.setState({
            logbog: logbog,
            isSaved: false,
            isSubmitting: false,
            validationResult: undefined
        });
    }

    componentDidMount() {
        var self = this;
        var id = this.props.match.params.id;
        var apiCaller = createApiCaller();

        if (id !== undefined && id.length > 0) {
            apiCaller.getLogbog(id).then(response => {
                self.setStateWithLogbog(response);
            });
        }
    }

    getLogbog(): Logbog {
        return this.state.logbog !== undefined ? this.state.logbog : new Logbog();
    }

    getErrorMessages() {
        return this.state.validationResult ? this.state.validationResult.errorMessages : [];
    }

    onLogbogChanged(fieldName: string, value: any) {
        let newState = this.state;
        if (newState.logbog !== undefined) {
            newState.logbog[fieldName] = value;
            this.setState(newState);
        }
    }

    onAfsnitChanged(fieldName: string, value: any, index: number) {
        let newState = this.state;
        if (newState.logbog !== undefined) {
            newState.logbog.logbogAfsnit[index][fieldName] = value;
            this.setState(newState);
        }
    }

    onLogbogSave() {
        this.setState({ isSubmitting: true });
        var self = this;
        if (this.state.logbog.id === undefined) {
            createApiCaller().createLogbog(self.state.logbog).then(response =>
                self.setState({ validationResult: response, isSaved: response.isValid, isSubmitting: false })
            );
        } else {
            createApiCaller().updateLogbog(self.state.logbog).then(response =>
                self.setState({ validationResult: response, isSaved: response.isValid, isSubmitting: false })
            );
        }
    }

    onLogbogDelete() {
        var self = this;

        var deleteLogbogPromise = createApiCaller().deleteLogbog(self.state.logbog.id);
        deleteLogbogPromise.then(function () {
            self.setState({ isRemoved: true });
        });
    }

    removeAfsnit(index: number) {
        let newState = this.state;
        if (newState.logbog !== undefined && index > -1) {
            newState.logbog.logbogAfsnit.splice(index, 1);
            this.setState(newState);
        }
    }

    getIsNew() {
        return this.state.logbog === undefined;
    }

    addAfsnit() {
        let afsnit = new LogbogAfsnit();
        let newState = this.state;

        if (newState.logbog !== undefined) {

            if (newState.logbog.logbogAfsnit === undefined) {
                newState.logbog.logbogAfsnit = [];
            }
       
            afsnit.order = newState.logbog.logbogAfsnit.length; // ToDo JMG: overvej at flytte til backend, da slet af afsnit midt i, potentielt forårsager afsnit med samme order
            newState.logbog.logbogAfsnit.push(afsnit);

            this.setState(newState);
        }
    }

    onSaved(msg: string) {
        NotificationQueue.push(new NotificationData(msg, '', 'success'));
        return <Redirect to='/logboeger' />;
    }
  
    render() {
        if (this.state.isSaved) {
            return this.onSaved('Logbogen blev gemt');
        }

        if (this.state.isRemoved) {
            return this.onSaved('Logbogen blev slettet');
        }

        return (
            <PageWrapper>
                <PageTitle title={'Logbøger'} />
                <ContentWrapper>
                    <LogbogCreateUpdate
                        logbog={this.getLogbog()}
                        errorMessages={this.getErrorMessages()}
                        addAfsnit={this.addAfsnit}
                        removeAfsnit={this.removeAfsnit}
                        onAfsnitChanged={this.onAfsnitChanged}
                        onLogbogChanged={this.onLogbogChanged}
                        onLogbogSave={this.onLogbogSave}
                        onLogbogDelete={this.onLogbogDelete}
                        isSubmitting={this.state.isSubmitting}
                        isNew={this.getIsNew()}
                    />
                </ContentWrapper>
            </PageWrapper>
        );
    }
}

export default LogbogCreateUpdateContainer;


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/pageComponents/Logbog/LogbogCreateUpdateContainer.tsx